/* eslint-disable import/no-cycle */
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  ViewEncapsulation,
  computed,
  inject,
  input,
} from '@angular/core'

import { FlxStyleModule, FlxThemeModule } from '@flowx/angular-theme'
import { PageTemplateConfig, isUserTaskRoot } from '@flowx/core-sdk'

import { FlxTreeNodeComponent } from '../../renderer/tree-node/tree-node.component'
import { FlxActionService } from '../../services/flx-action.service'
import { emitScreenAnalyticsOnDisplay } from '../../utils/screen-analytics.utils'

@Component({
  selector: 'flx-page',
  standalone: true,
  imports: [FlxTreeNodeComponent, FlxThemeModule, FlxStyleModule],
  templateUrl: './flx-page.component.html',
  styleUrl: './flx-page.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxPageComponent implements OnInit {
  #actionService = inject(FlxActionService)
  #destroyRef = inject(DestroyRef)

  templateConfig = input.required<PageTemplateConfig>()

  displayOptions = computed(() => this.templateConfig().displayOptions)
  flowxProps = computed(() => this.displayOptions().flowxProps)
  style = computed(() => this.displayOptions().style)

  ngOnInit(): void {
    this.#actionService.runOnLoadEvent(this.templateConfig(), this.#destroyRef, isUserTaskRoot)
    this.#actionService.runOnDisplayEvent(this.templateConfig(), this.#destroyRef, isUserTaskRoot)
    emitScreenAnalyticsOnDisplay(this.templateConfig(), this.flowxProps(), this.#destroyRef)
  }
}
